import images from "../../web-sh/src/assets/images";

import PlanNoticeImg from "./plan-notice.png"
import Block2FAImg from "./block-2fa.png"
import ImportantImg from "./important.png"
import WelcomeImg from "./welcome.svg"
import ExtensionImg from "./extension.png"
import WelcomeToLockerEnterpriseImg from "./welcome-to-locker-enterprise.svg"

import Feat1Img from './utilities/feat-1.svg'
import Feat2Img from './utilities/feat-2.svg'
import Feat3Img from './utilities/feat-3.svg'
import Feat4Img from './utilities/feat-4.svg'
import Feat5Img from './utilities/feat-5.svg'
import Feat6Img from './utilities/feat-6.svg'
import Feat7Img from './utilities/feat-7.svg'
import Feat8Img from './utilities/feat-8.svg'

import CardImage from "./icons/cards/card.svg";
import VisaImage from "./icons/cards/visa.svg";
import MasterImage from "./icons/cards/master.svg";
import AmexImage from "./icons/cards/amex.svg";
import DiscoverImage from "./icons/cards/discover.svg";
import JCBImage from "./icons/cards/jcb.svg"

import WelAddPWImg from "./welcome-tour/add-pw.svg";
import WelBrowseItemImg from "./welcome-tour/browse-items.svg";
import WelImportFileImg from "./welcome-tour/import-file.svg";
import WelViewAutofillImg from "./welcome-tour/view-autofill.svg";
import WelViewProfileImg from "./welcome-tour/view-profile.svg";
import WelViewSettingsImg from "./welcome-tour/view-settings.svg";

import ChromeIcon from './icons/browsers/chrome.svg'
import FirefoxIcon from './icons/browsers/firefox.svg'
import EdgeIcon from './icons/browsers/edge.svg'
import BraveIcon from './icons/browsers/brave.svg'
import SafariIcon from './icons/browsers/safari.svg'

import BannerIcon from './icons/banner.svg'

import SaleEnImg from './sale/sale-en.svg'
import SaleViImg from './sale/sale-vi.svg'
import AuthBgImage from "./auth-bg-image.svg";

import AuthLogo from './logos/auth-logo.svg';

images.AuthBgImage = AuthBgImage

export default {
  ...images,

  PlanNoticeImg,
  Block2FAImg,
  ImportantImg,
  WelcomeImg,
  ExtensionImg,
  WelcomeToLockerEnterpriseImg,

  Feat1Img,
  Feat2Img,
  Feat3Img,
  Feat4Img,
  Feat5Img,
  Feat6Img,
  Feat7Img,
  Feat8Img,

  CardImage,
  VisaImage,
  MasterImage,
  AmexImage,
  DiscoverImage,
  JCBImage,

  WelAddPWImg,
  WelBrowseItemImg,
  WelImportFileImg,
  WelViewAutofillImg,
  WelViewProfileImg,
  WelViewSettingsImg,

  ChromeIcon,
  FirefoxIcon,
  EdgeIcon,
  BraveIcon,
  SafariIcon,

  BannerIcon,

  SaleEnImg,
  SaleViImg,

  AuthLogo
}